module.exports = __webpack_public_path__ + "0a51a21593766a0a3a81f86d7a7e7e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/mano.png
// module id = 234
// module chunks = 0